import boxConfigurations from '@data/boxConfigurations.json'

import { filterBonusGroups } from '@lib/customization/bonus-items'
import styles from './styles/CustomizationModal.module.scss'

type CustomizationProgressProps = {
	currentStep: number
	customizationType: 'NMC' | 'RMC'
	subscriptionProductSKU: string
}

interface CustomizationStep {
	name: string
	collection_slug: string
	max_items: number
}

// TODO: retrieve from Prismic

export default function CustomizationModalProgress({
	currentStep = 2,
	customizationType,
	subscriptionProductSKU
}: CustomizationProgressProps) {
	const boxConfiguration = boxConfigurations.find((config) =>
		config.product_skus.some((sku) => sku.sku === subscriptionProductSKU)
	)

	if (!boxConfiguration) {
		console.error(`No box configuration found for SKU: ${subscriptionProductSKU}`)
		return <div>Error: No box configuration found</div>
	}

	const allSteps: CustomizationStep[] =
		customizationType === 'NMC'
			? boxConfiguration.nmc.customization_groups
			: boxConfiguration.rmc.customization_groups
	const steps: CustomizationStep[] = filterBonusGroups(allSteps as any[]) as CustomizationStep[]
	// How to use:
	// Mark step as complete add - ${styles.completed to stepItem}
	// Mark step as active add - ${styles.active to stepItem}

	// TODO: props => array with steps and based on the current step highlight the active step and complete previous one
	return (
		<div className={styles.stepperWrapper}>
			{steps.map((step, idx) => {
				const { name } = step
				// eslint-disable-next-line no-nested-ternary
				const status = idx < currentStep ? 'completed' : idx === currentStep ? 'active' : 'upcoming'
				let stepStatusStyle = null
				switch (status) {
					case 'completed':
						stepStatusStyle = `${styles.completed}`
						break
					case 'active':
						stepStatusStyle = `${styles.active}`
						break
					case 'upcoming':
						stepStatusStyle = ``
						break
					default:
						break
				}
				return (
					<div
						className={`${styles.stepperItem}${stepStatusStyle ? ` ${stepStatusStyle}` : ``}`}
						// eslint-disable-next-line react/no-array-index-key
						key={`customization-progress-${idx}`}
					>
						<div className={styles.stepCounter} />
						<div className={styles.stepName}>{name}</div>
					</div>
				)
			})}
		</div>
	)
}
